/**
 * Legacy audit rows use parallel arrays under `data.updated_at`.
 * Tripletex / hour sync rows use a plain JSON object in `data`.
 */
export function isBatchHistoryDataShape(parsed) {
  return (
    parsed &&
    typeof parsed === "object" &&
    !Array.isArray(parsed) &&
    Array.isArray(parsed.updated_at)
  );
}

/**
 * API normally returns `changes` as an object. Older payloads may be JSON strings or `_legacy` wrapper keys.
 */
export function parseHistoryChanges(raw) {
  if (raw == null || raw === "") return {};
  if (typeof raw === "object" && !Array.isArray(raw)) return raw;
  if (typeof raw === "string") {
    const s = raw.trim();
    if (!s) return {};
    try {
      return JSON.parse(s);
    } catch {
      const parsedLegacy = parseLegacyHashStyleChanges(s);
      if (parsedLegacy) return parsedLegacy;
      return { _legacy: raw };
    }
  }
  return {};
}

function parseLegacyHashStyleChanges(source) {
  if (!source.startsWith("{") || !source.endsWith("}") || !source.includes("=>")) {
    return null;
  }

  const result = {};
  const pairRegex =
    /:([a-zA-Z0-9_]+)\s*=>\s*("(?:\\.|[^"\\])*"|true|false|nil|-?\d+(?:\.\d+)?)/g;

  let match = null;
  let found = false;
  while ((match = pairRegex.exec(source)) !== null) {
    found = true;
    const key = match[1];
    const rawValue = match[2];
    result[key] = parseLegacyValue(rawValue);
  }

  return found ? result : null;
}

function parseLegacyValue(rawValue) {
  if (rawValue === "true") return true;
  if (rawValue === "false") return false;
  if (rawValue === "nil") return null;
  if (/^-?\d+(?:\.\d+)?$/.test(rawValue)) return Number(rawValue);

  if (rawValue.startsWith('"') && rawValue.endsWith('"')) {
    const content = rawValue.slice(1, -1);
    return content.replace(/\\"/g, '"').replace(/\\\\/g, "\\");
  }

  return rawValue;
}
